import {AccessoryProfileModel} from "./accessory-profile.model";
import {AccessoryTypeModel} from "./accessory-type.model";
import {EdgeModel} from "./edge.model";
import {FamilyModel} from "./family.model";
import {FinishModel} from "./finish.model";
import {MainColorModel} from "./main-color.model";
import {MaterialModel} from "./material.model";
import {ProductAccessoriesModel} from "./product-accessories.model";
import {ProductImageModel} from "./product-image.model";
import {ProductMakerMarksIconsModel} from "./product-maker-marks-icons.model";
import {ProductRecommendedColorsModel} from "./product-recommended-colors.model";
import {ProductResourcesModel} from "./product-resources.model";
import {ProductSpecificationIconsModel} from "./product-specification-icons.model";
import {SubColorModel} from "./sub-color.model";
import {SubNameModel} from "./sub-name.model";
import {UnitOfMeasurementModel} from "./unit-of-measurement.model";
import {ProductCategoryModel} from "./product-category.model";
import {ProductCollectionModel} from "./product-collection.model";
import {ProductVideoModel} from "./product-video.model";
import {AccessoryCategoryModel} from "./accessory-category.model";
import {ProjectModel} from "./project.model";

export class ProductModel {
  accessory_profile_id?: any;
  apply_glue_calculator?: any;
  consumables_finish_id?: any;
  consumables_application_id?: any;
  blog_link?: any;
  created_at?: any;
  edge_id?: any;
  edge_name?: any;
  family_id?: any;
  family_name?: any;
  finish_id?: any;
  product_collection_name?: string;
  product_category_name?: any;
  full_description?: any;
  hero_finish?: any;
  hero_category_sku?: any;
  hero_sku?: any;
  id?: any;
  is_available?: any;
  is_new?: any;
  last_ordered?: any;
  last_quoted?: any;
  lead_time?: any;
  length?: any;
  main_color_id?: any;
  material_id?: any;
  product_collection_id?: any;
  product_category_id?: any;
  modified_at?: any;
  moi?: any;
  moq?: any;
  qr_code_link?: any;
  release_date?: any;
  sealer_calculator?: any;
  secondary_sample_sku?: any;
  short_description?: any;
  sku?: any;
  slip_rating?: any;
  status?: any;
  sub_color_id?: any;
  texture_guide?: any;
  thickness?: any;
  title?: any;
  type?: any;
  unit_of_measurment_id?: any;
  video_link?: any;
  website_url?: any;
  width?: any;
  size?: any;
  height?: any;
  diameter?: any;
  opening?: any;
  weight?: any;
  video_url?: any;
  blog_url?: any;
  finish_name?: any;
  sub_name?: any;
  category_name?: any;
  dimensions?: any;
  unit_of_measurement_name?: any;
  is_feature?: any;
  is_all_in_one?: any;
  category?: any;
  material_name?: any;
  material?: MaterialModel;
  finish?: FinishModel;
  edge?: EdgeModel;
  accessoryProfile?: AccessoryProfileModel;
  accessoryCategory?: AccessoryCategoryModel;
  accesoryType?: AccessoryTypeModel;
  family?: FamilyModel;
  subname?: SubNameModel;
  mainColor?: MainColorModel;
  subColor?: SubColorModel;
  unitOfMeasurement?: UnitOfMeasurementModel;
  productAccessories?: ProductAccessoriesModel;
  productImages?: ProductImageModel[];
  productVideos?: ProductVideoModel[];
  productMakerMarksIcons?: ProductMakerMarksIconsModel[];
  productRecommendedColors?: ProductRecommendedColorsModel[];
  productResources?: ProductResourcesModel[];
  productSpecificationIcons?: ProductSpecificationIconsModel[];
  productProjectImagery?: ProductImageModel[];
  availableFinishes?: FinishModel[];
  newAvailableFinishes?: FinishModel[];
  availableSize?: any;
  finishImage?: ProductImageModel;
  formatImage?: ProductImageModel;
  seamlessTextureImages?: ProductImageModel[];
  productResourcesDocument?: ProductResourcesModel[];
  productInstallationResources?: ProductResourcesModel[];
  availableFamily?: FamilyModel[];
  availableMaterial?: MaterialModel[];
  is_favorite?: any;
  formatHeroImage?: any;
  familyHeroImage?: any;
  sizing_diagram?: string;
  category_id?: number;
  is_feature_profile?: string;
  price?: any;
  rrp_price?: any;
  is_sale?: string;
  quantity?: any;
  color_range_pdf?: string;
  url_slug?: any;
  meta_title?: any;
  meta_description?: any;
  custom_dimension?: any;
  customDimension?: any;
  availableCategories?: any;
  stock?: any;
  availableThickness?: any;
  availableEdge?: any;
  calculatedLeadTime?: any;
  availableFinishesCount?: any;
  consumable_calculators?: any;
  total_premium_sealing_price?: any;
  total_adhesive_price?: any;
  total_adhesive_premium_price?: any;
  color_variation_score?: any;
  format_icon: any;
  product_type_id: any
  oldQuantity?: any;
  includeWastage?: boolean
  currentWastage?: number;
  recommendedQuantity?: number;
  finish_edge_name?: number;
  productCollection?: ProductCollectionModel;
  productCategory?: ProductCategoryModel;
  product?: any
  is_deleted?: any;
  disabledAdhesivePrice?: any;
  disabledSealerPriceDefender?: any;
  disabledSealerPriceGold?: any;
  productUnitOfMeasurements?: any;
  applied_credit?: any;
  selected_uom?: any;
  selected_moq?: any;
  entered_quantity?: any;
  unit_of_measurement_id?: any;
  ul_available_qty?: any;
  onHandStock?: { total_qty: number; allocated_qty: number; available_qty: number; is_over_allocated: boolean };
  relatedFeatureProject?: ProjectModel[];
  productMetaTitle?: any;
  productMetaDescription?: any;
}
